import React, { forwardRef, WheelEventHandler } from "react";
import { twMerge } from "tailwind-merge";

interface NumberInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "value"> {
    value: number | null;
    className?: string;
}

const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
    ({ value, className, ...rest }, ref) => {
        const handleScroll: WheelEventHandler<HTMLInputElement> = ({ currentTarget }) => {
            currentTarget.blur();
        };

        return (
            <input
                ref={ref}
                type="number"
                value={value ?? ""}
                className={twMerge(
                    `w-full rounded-2xl border border-zing-gray-400 bg-black px-2 py-3 text-center !text-zing-40-48 font-semibold text-white placeholder-zing-gray-400 outline-none focus:border-zing-blue-200 female:border-zing-neutral-cool-grey-400 female:bg-transparent female:text-black female:placeholder-zing-neutral-cool-grey-400 female:focus:border-zing-warm-tangerine-400`,
                    className
                )}
                onWheel={handleScroll}
                enterKeyHint="enter"
                {...rest}
            />
        );
    }
);

export default NumberInput;
